<template>
    <div>
        <el-dialog :visible.sync="visible" :close-on-click-modal="false" :before-close="close"  width="750px">
            <div slot="title">
                <z-title title="额外合计项目"></z-title>
            </div>
            <div class="extraitem plr-20">
                <el-tabs v-model="activeName" ref="tabs">
                    <el-tab-pane label="额外项目" name="1">
                        <el-row>
                            <el-col class="left" :span="7">
                                <el-tree ref="eltree2" :data="itemsExTree" node-key="id" :props="exTreeProps" show-checkbox @check-change="handleCheckChange2"></el-tree>
                            </el-col>
                            <el-col class="right" :span="17">
                                <div>项目名称</div>
                                <div class="item">
                                    <div v-for="item,index in itemsList" class="flex-n fac fjb mt-10">
                                        <div class="w-120">{{item.itemName}}</div>
                                        <div class="mr-10 textnowrap">单价</div>  <el-input-number placeholder="价格" size="medium" class="mr-10 w-120"  v-model="item.itemPrice" :controls="false"
                                                                                                 :min="0" :precision="2"  ></el-input-number>
                                        <div class="mr-10 textnowrap">数量</div> <el-input-number step-strictly size="medium" class="w-60 mr-10"  v-model="item.itemCount" :controls="false"
                                                                                                :min="1" ></el-input-number>
                                        <el-button type="primary" class="ele-btn-small" size="medium" @click="remove(item,index,0)"><i class="el-icon-minus"></i></el-button>
                                    </div>
                                </div>
                                <div  class="flex-n fac fje mt-10">
                                    <div>总价格：{{totalprice}}元</div>
                                </div>
                            </el-col>
                        </el-row>

                    </el-tab-pane>
                    <el-tab-pane label="点餐项目" v-if="statetype!='02'" name="2">
                        <el-row>
                            <el-col class="left" :span="7">
                                <el-tree ref="eltree" :data="itemsFoodTree" node-key="id"  :props="foodTreeProps" show-checkbox @check-change="handleCheckChange"></el-tree>
                            </el-col>
                            <el-col class="right" :span="17">
                                <div>菜品名称</div>
                                <div class="item">
                                    <div v-for="item,index in foodsList" class="flex-n fac fjb mt-10">
                                        <div class="w-120">{{item.foodName}}</div>
                                        <div class="mr-10 textnowrap">单价</div>  <el-input-number placeholder="价格" size="medium" class="mr-10 w-120"  v-model="item.foodPrice" :controls="false"
                                                                                                 :min="0" :precision="2"  ></el-input-number>
                                        <div class="mr-10 textnowrap">数量</div> <el-input-number step-strictly size="medium" class="w-60 mr-10"  v-model="item.foodCount" :controls="false"
                                                                                                :min="1" ></el-input-number>
                                        <el-button type="primary" class="ele-btn-small" size="medium" @click="remove(item,index,1)"><i class="el-icon-minus"></i></el-button>
                                    </div>
                                </div>
                                <div  class="flex-n fac fje mt-10">
                                    <div>总价格：{{totalprice}}元</div>
                                </div>
                            </el-col>
                        </el-row>
                    </el-tab-pane>
                </el-tabs>
            </div>
            <div class="flex-n fjc fac mt-10">
                <el-button type="primary" class="mr-20" @click="makesure">确 定</el-button>
                <el-button @click="close">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import ZTitle from "../../components/ZTitle";

    export default {
        components: {ZTitle},
        name: "itemextra",
        props: {
            visible: Boolean,
            statetype:String,
            data: Object,
            //需要传递已选中得值

        },
        model: {
            prop: 'data',
            event:'input'
        },
        computed:{
            totalprice(){
                var money=0;
                for(var i in this.foodsList){
                    money+=this.foodsList[i].foodPrice*this.foodsList[i].foodCount;
                }
                for(var i in this.itemsList){
                    money+=this.itemsList[i].itemPrice*this.itemsList[i].itemCount;
                }
                return money.toFixed(2);
            }
        },
        data(){
            return{
                activeName:'1',
                state:0,
                itemsFoodTree:[],
                itemsExTree:[],//读取的额外项目节点
                itemsList:[],//额外项目选中
                foodsList:[],//点餐项目选中
                exTreeProps: {
                    label: 'itemName',
                    children:'itemsExs',
                },
                foodTreeProps: {
                    label: 'foodName',
                    children:'itemsFoods',
                },
                olditemsList:[],
                oldfoodsList:[]
            }
        },
        mounted(){

        },
        watch:{
            'data.itemsExTree'(newval,oldval) {
                // console.log(newval)
                // if(newval){

                    this.itemsList=newval;
                    this.foodsList=this.data.itemsFoodTree;
                    // this.getitemsExTree();
                    // this.getitemsFoodTree();
                // }
            },
            visible(newval,oldval){
                if(newval){
                    if(this.statetype=='02'){
                        this.olditemsList=this.itemsList;
                        this.activeName='1';
                        this.getitemsExTree();
                    }else {
                        this.olditemsList = this.itemsList;
                        this.oldfoodsList = this.foodsList;
                        this.activeName = '1';
                        this.getitemsExTree();
                        this.getitemsFoodTree();
                    }
                }
            }
        },
        methods:{
            //获取额外项目树
            getitemsExTree(){
                this.$axios.post('/itemsEx/itemsExTreeByStoreId',{
                    "storeId":this.$root.getStorage('storeId')
                }).then(res=>{
                    console.log('额外项目树',res)
                    var itemsExTree=res.data.itemsExTree;
                    for(var i in itemsExTree){
                        itemsExTree[i].itemName=itemsExTree[i].itemTypeName;
                        for(var j in itemsExTree[i].itemsExs){
                            itemsExTree[i].itemsExs[j].itemCount=1;
                            itemsExTree[i].itemsExs[j].packageId=itemsExTree[i].itemTypeCode;
                        }
                        if(itemsExTree[i].itemsExs.length==0){
                            itemsExTree[i].disabled=true;
                        }
                    }
                    this.itemsExTree=itemsExTree;
                    if(this.visible){
                        var idlist=[];
                        for(var i in this.itemsList){
                            idlist.push(this.itemsList[i].id)
                        }
                        this.$refs.eltree2.setCheckedKeys(idlist);
                    }
                }).catch(err=>{
                    this.$message.error(err.msg);
                })
            },
            getitemsFoodTree(){
                this.$axios.post('/itemsFood/itemsFoodTreeByStoreId',{
                    "storeId":this.$root.getStorage('storeId')
                }).then(res=>{
                    console.log('套餐项目树',res)
                    var itemsFoodTree=res.data.itemsFoodTree;
                    for(var i in itemsFoodTree){
                        itemsFoodTree[i].foodName=itemsFoodTree[i].foodTypeName;
                        for(var j in itemsFoodTree[i].itemsFoods){
                            itemsFoodTree[i].itemsFoods[j].foodCount=1;
                            itemsFoodTree[i].itemsFoods[j].packageId=itemsFoodTree[i].foodTypeCode;
                        }
                        if(itemsFoodTree[i].itemsFoods.length==0){
                            itemsFoodTree[i].disabled=true;
                        }
                    }
                    this.itemsFoodTree=itemsFoodTree;
                    if(this.visible){
                        var idlist=[];
                        console.log(this.foodsList)
                        for(var i in this.foodsList){
                            idlist.push(this.foodsList[i].id)
                        }
                        this.$refs.eltree.setCheckedKeys(idlist);
                    }

                }).catch(err=>{
                    this.$message.error(err.msg);
                })
            },
            close() {
                this.itemsList=this.olditemsList;
                this.foodsList=this.oldfoodsList;
                this.$emit('update:visible', false)
            },
            remove(item,index,state){
                console.log(item,index)
                if(state==0){
                    this.itemsList.splice(index,1);
                    item.itemCount=1;
                    this.$refs.eltree2.setChecked(item,false);
                }else{
                    this.foodsList.splice(index,1);
                    item.foodCount=1;
                    this.$refs.eltree.setChecked(item,false);
                }


            },
            handleCheckChange() {
                var a=this.$refs.eltree.getCheckedNodes(true);//只要叶子节点
                var arr = [];
                a.forEach((item) => {
                    for(var i in this.foodsList) {
                        if(this.foodsList[i] == item){
                            break;
                        }
                        if (this.foodsList[i] != item&&i==this.foodsList.length-1) {
                            item.foodCount=1;
                        }
                    }
                    arr.unshift(item)
                })
                this.foodsList=arr;
            },
            handleCheckChange2(){
                var a=this.$refs.eltree2.getCheckedNodes(true);//只要叶子节点
                console.log(a)
                var arr = [];
                a.forEach((item) => {
                    for(var i in this.itemsList) {
                        if(this.itemsList[i] == item){
                            break;
                        }
                        if (this.itemsList[i] != item&&i==this.itemsList.length-1) {
                            item.itemCount=1;
                        }
                    }
                    arr.unshift(item)
                })
                this.itemsList=arr;
            },
            makesure(){
                var data={};
                data={
                    itemsExTree:this.itemsList,
                    itemsFoodTree:this.foodsList
                }
                this.$emit('input',data)
                this.$emit('getTotal',{'totalprice':this.totalprice});
                this.$emit('update:visible', false)
            },
            resetCard(){
                this.itemsList=[];
                this.foodsList=[];
            },
        }
    }
</script>

<style scoped lang="scss">
    .extraitem{
        position: relative;
        .btn{
            position: absolute;
            top: 10px;
            z-index: 9999;
            right: 20px;
        }
        .left{
            border-right: 1px solid #eee;
            height: 260px;
            overflow-y: scroll;
        }
        .right{
            .item{
                height: 200px;
                overflow-y: scroll;
            }
            padding-left: 20px;
        }
    }
</style>